import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { createOrganization, getOrganizationById, updateOrganization } from '../../api';

const AddOrganization = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEditMode = Boolean(id);
    
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        contactEmail: '',
        contactPhone: '',
        address: { street: '', city: '', state: '', zip: '', country: '' },
        industry: '',
    });

    useEffect(() => {
        if (isEditMode) {
            const fetchOrganization = async () => {
                try {
                    const data = await getOrganizationById(id);
                    setFormData(data.data);
                } catch (error) {
                    alert('Error fetching organization details!');
                    navigate('/organizations');
                }
            };
            fetchOrganization();
        }
    }, [id, isEditMode, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            address: { ...prev.address, [name]: value },
        }));
    };

    const handleSubmit = async () => {
        try {
            if (isEditMode) {
                await updateOrganization(id, formData);
                alert('Organization updated successfully!');
            } else {
                await createOrganization(formData);
                alert('Organization created successfully!');
            }
            navigate('/organizations');
        } catch (error) {
            alert(`Error ${isEditMode ? 'updating' : 'creating'} organization!`);
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" p={3}>
            <Typography variant="h5" mb={2}>
                {isEditMode ? 'Edit' : 'Add'} Organization
            </Typography>
            <TextField 
                label="Name" 
                name="name" 
                value={formData.name} 
                fullWidth 
                margin="normal" 
                onChange={handleChange} 
            />
            <TextField 
                label="Description" 
                name="description" 
                value={formData.description} 
                fullWidth 
                margin="normal" 
                onChange={handleChange} 
            />
            <TextField 
                label="Contact Email" 
                name="contactEmail" 
                value={formData.contactEmail} 
                fullWidth 
                margin="normal" 
                onChange={handleChange} 
            />
            <TextField 
                label="Contact Phone" 
                name="contactPhone" 
                value={formData.contactPhone} 
                fullWidth 
                margin="normal" 
                onChange={handleChange} 
            />
            <Typography variant="subtitle1" mt={2} mb={1}>
                Address
            </Typography>
            <TextField 
                label="Street" 
                name="street" 
                value={formData.address.street} 
                fullWidth 
                margin="normal" 
                onChange={handleAddressChange} 
            />
            <TextField 
                label="City" 
                name="city" 
                value={formData.address.city} 
                fullWidth 
                margin="normal" 
                onChange={handleAddressChange} 
            />
            <TextField 
                label="State" 
                name="state" 
                value={formData.address.state} 
                fullWidth 
                margin="normal" 
                onChange={handleAddressChange} 
            />
            <TextField 
                label="ZIP" 
                name="zip" 
                value={formData.address.zip} 
                fullWidth 
                margin="normal" 
                onChange={handleAddressChange} 
            />
            <TextField 
                label="Country" 
                name="country" 
                value={formData.address.country} 
                fullWidth 
                margin="normal" 
                onChange={handleAddressChange} 
            />
            <TextField 
                label="Industry" 
                name="industry" 
                value={formData.industry} 
                fullWidth 
                margin="normal" 
                onChange={handleChange} 
            />
            <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
                <Button variant="contained" color="secondary" onClick={() => navigate('/organizations')}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={handleSubmit}>
                    {isEditMode ? 'Update' : 'Add'} Organization
                </Button>
            </Box>
        </Box>
    );
};

export default AddOrganization;
